import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {ControlContainer, FormControl, FormGroup, FormGroupDirective} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS,} from '@angular/material/core';
import {ComponentManagerService, FormatService, FormService, GppDateAdapter} from "@fgpp-ui/components";
import {UserSettingsService} from "../../../user-settings/services/user-settings.service";
import {MAT_DAYJS_DATE_ADAPTER_OPTIONS} from "@fgpp-ui/grid";

const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MMMM-YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [FormService, ComponentManagerService,
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    {provide: DateAdapter, useClass: GppDateAdapter},
    {provide: MAT_DAYJS_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerComponent implements OnInit {

  formService = inject(FormService);
  formatService: FormatService = inject(FormatService);
  userSettingsService = inject(UserSettingsService);
  @Input() startDateMapping: string;
  @Input() endDateMapping: string;
  @Input() required = false;
  formGroup: FormGroup;
  private controlContainer = inject(ControlContainer);
  range = new FormGroup({
    start: new FormControl<string | null>(null),
    end: new FormControl<string | null>(null),
  });

  ngOnInit() {
    this.formatService.format.dateFormat = this.userSettingsService.getPreferences().dateFormat;
    this.formatService.format.timeFormat = this.userSettingsService.getPreferences().timeFormat;
    this.formGroup = (this.controlContainer as FormGroupDirective).form;
  }
}
